// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Document Info Panel Styles */

.document-info-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2500;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.document-info-panel {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease;
  overflow: hidden;
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.document-info-header {
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
}

.document-info-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  transition: color 0.2s;
}

.close-btn:hover {
  color: #333;
}

.document-info-content {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}

.info-row {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 12px;
  margin-bottom: 16px;
  align-items: flex-start;
}

.info-row label {
  font-weight: 500;
  color: #666;
  font-size: 14px;
}

.info-value {
  color: #333;
  font-size: 14px;
  word-break: break-word;
  padding: 6px 8px;
  background: #f5f5f5;
  border-radius: 4px;
  display: block;
  line-height: 1.4;
  max-height: 100px;
  overflow-y: auto;
}

.document-info-footer {
  padding: 12px 20px;
  border-top: 1px solid #e0e0e0;
  background: #f8f9fa;
  font-size: 13px;
  color: #666;
}

.info-hint {
  margin: 0;
  font-style: italic;
}

/* Responsive */
@media (max-width: 600px) {
  .document-info-panel {
    width: 95%;
    max-height: 90vh;
  }

  .info-row {
    grid-template-columns: 1fr;
    gap: 6px;
  }

  .document-info-header {
    padding: 16px;
  }

  .document-info-content {
    padding: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/DocumentInfoPanel.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Document Info Panel Styles */\r\n\r\n.document-info-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 2500;\r\n  animation: fadeIn 0.2s ease;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.document-info-panel {\r\n  background: white;\r\n  border-radius: 12px;\r\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\r\n  width: 90%;\r\n  max-width: 500px;\r\n  max-height: 80vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  animation: slideUp 0.3s ease;\r\n  overflow: hidden;\r\n}\r\n\r\n@keyframes slideUp {\r\n  from {\r\n    transform: translateY(20px);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateY(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.document-info-header {\r\n  padding: 20px;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background: #f8f9fa;\r\n}\r\n\r\n.document-info-header h2 {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.close-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #666;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.close-btn:hover {\r\n  color: #333;\r\n}\r\n\r\n.document-info-content {\r\n  padding: 20px;\r\n  overflow-y: auto;\r\n  flex: 1;\r\n}\r\n\r\n.info-row {\r\n  display: grid;\r\n  grid-template-columns: 120px 1fr;\r\n  gap: 12px;\r\n  margin-bottom: 16px;\r\n  align-items: flex-start;\r\n}\r\n\r\n.info-row label {\r\n  font-weight: 500;\r\n  color: #666;\r\n  font-size: 14px;\r\n}\r\n\r\n.info-value {\r\n  color: #333;\r\n  font-size: 14px;\r\n  word-break: break-word;\r\n  padding: 6px 8px;\r\n  background: #f5f5f5;\r\n  border-radius: 4px;\r\n  display: block;\r\n  line-height: 1.4;\r\n  max-height: 100px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.document-info-footer {\r\n  padding: 12px 20px;\r\n  border-top: 1px solid #e0e0e0;\r\n  background: #f8f9fa;\r\n  font-size: 13px;\r\n  color: #666;\r\n}\r\n\r\n.info-hint {\r\n  margin: 0;\r\n  font-style: italic;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 600px) {\r\n  .document-info-panel {\r\n    width: 95%;\r\n    max-height: 90vh;\r\n  }\r\n\r\n  .info-row {\r\n    grid-template-columns: 1fr;\r\n    gap: 6px;\r\n  }\r\n\r\n  .document-info-header {\r\n    padding: 16px;\r\n  }\r\n\r\n  .document-info-content {\r\n    padding: 16px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
